import { LoadingIndicator } from '../../common/components/loading-indicator';
import { VStack } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import { ResultsCard } from './results-card';
import { useDexResults } from './use-dex-results';
import { DexResultsLeftPaneFrControls } from './dex-results-left-pane-fr-controls';

export const DexResultsLeftPane = observer(function DexResultsLeftPane({
    listContainerRef,
    testId,
}: {
    listContainerRef: React.MutableRefObject<HTMLDivElement | null>;
    testId?: string;
}): React.ReactElement {
    const { dexResultsStore, getDexResultsQuery } = useDexResults();
    const { dexResultsViews, selectedQueryAndResult, selectedQueryAndSummary } = dexResultsStore;
    const selectedResultId = selectedQueryAndResult?.result.incomingMessageId;
    const selectedSummaryId = selectedQueryAndSummary?.query.outgoingMessageId;

    return (
        <VStack
            data-testid={testId}
            minWidth="300px"
            maxWidth="300px"
            h="100%"
            overflowY="auto"
            bgColor="surface.foreground"
            padding="16px"
            ref={listContainerRef}
        >
            <DexResultsLeftPaneFrControls />
            {getDexResultsQuery.isInitialLoading ? (
                <LoadingIndicator />
            ) : (
                dexResultsViews.map((dexResultsView) => {
                    return (
                        <ResultsCard
                            key={dexResultsView.query.outgoingMessageId}
                            dexResultsView={dexResultsView}
                            selectedResultId={selectedResultId}
                            selectedSummaryId={selectedSummaryId}
                        />
                    );
                })
            )}
        </VStack>
    );
});
